<template>
<div>
  <img src="../assets/403.png" alt="" :style="{height:parkHeight}">
</div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: "undefined",
  data() {
    return {
      parkHeight:''
    }
  },
  created(){
    this.vuexAllPark(false)
    this.parkHeight= document.documentElement.clientHeight+ 'px'
    console.log(this.parkHeight )
  },
  methods:{
    ...mapMutations([
      'vuexAllPark'
    ]),
  },
  // beforeRouterLeave(to,from){
  //   console.log(to)
  //   this.vuexAllPark(true)

  // }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
img {
  width: 100%;
  // height: 1306px;
}
</style>



// WEBPACK FOOTER //
// src/components/undefined.vue